import React, { Component } from 'react';
import { Row, Col, Button, Form, FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import { fbManufacturers, firebaseDb } from '../../firebase';
import {withRouter} from 'react-router-dom';
import SimpleModal from '../widgets/modals/simplemodal';

class AddManufacturer extends Component {
    state = {
        manufacturer_name:'',
        manufacturer_error:false,
        error_msg:'',
        showModal: false,
        pageLoading: false
    }

    componentWillMount = () => {
        if(this.props.match.params.id){
            this.setState({
                pageLoading: true
            });
        }
    }

    componentDidMount = () => {
        if(this.props.match.params.id){
            firebaseDb.ref(`manufacturers/${this.props.match.params.id}`).once('value').then((snap)=>{
                let manufacturer = snap.val();
                this.setState({
                    manufacturer_name:manufacturer.name,
                    pageLoading: false
                });
            });
        }
    }

    render() {
        if(this.state.pageLoading){
            return (
                <div><h3>Loading...</h3></div>
            );
        }
        return (
            <div>
                {
                    this.state.showModal ?
                    <SimpleModal
                        showOnLoad={true}
                         title="It was successful"
                         okBtn="Ok"
                        okBtnClicked={()=>{
                            this.props.history.push({
                                pathname: "/dashboard"
                            });
                        }}
                        details="It was success full. Click Ok To go to the dashboard page." />
                    : null
                }
                <Row><Col><h2>Add New Manufacturer</h2></Col></Row>
                <Row>
                    <Col>
                    <Form onSubmit={(e)=>{
                        e.preventDefault();
                        if(this.state.manufacturer_name===''){
                            this.setState({
                                manufacturer_error: true,
                                error_msg:'Required'
                            });
                        }else{
                            this.setState({
                                manufacturer_error: false,
                                error_msg:''
                            });
                            if(this.props.match.params.id){
                                firebaseDb.ref(`manufacturers/${this.props.match.params.id}`).update({
                                    name: this.state.manufacturer_name
                                }).then((s)=>{
                                    this.setState({
                                        showModal: true
                                    });
                                });
                            }else{
                                fbManufacturers.push({
                                    name: this.state.manufacturer_name
                                }).then((s)=>{
                                    this.setState({
                                        showModal: true,
                                        manufacturer_name:''
                                    });
                                });
                            }
                        }
                    }}>
                        <FormGroup row>
                            <Col sm="12">
                                <Label for="manufacturer_name">Manufacturer Name</Label>
                                <Input 
                                    name="manufacturer_name" 
                                    id="manufacturer_name" 
                                    placeholder="Enter a name"
                                    value={this.state.manufacturer_name}
                                    onChange={(e)=>{
                                        this.setState({
                                            manufacturer_name: e.target.value
                                        });
                                    }}
                                    invalid={this.state.manufacturer_error ? true : false}
                                />
                                    {
                                        this.state.manufacturer_error ?
                                            <FormFeedback tooltip>{this.state.error_msg}</FormFeedback>
                                        : null
                                    }
                            </Col>
                        </FormGroup>
                        <br/>
                        <Button type="submit">Save</Button>
                    </Form>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default withRouter(AddManufacturer);


// WEBPACK FOOTER //
// ./src/components/dashboard/addmanufacturer.js